import { render, staticRenderFns } from "./RouletteRoundPreview.vue?vue&type=template&id=10a486f7&scoped=true"
import script from "./RouletteRoundPreview.vue?vue&type=script&lang=js"
export * from "./RouletteRoundPreview.vue?vue&type=script&lang=js"
import style0 from "./RouletteRoundPreview.vue?vue&type=style&index=0&id=10a486f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a486f7",
  null
  
)

export default component.exports